import { describeErrors } from './back-errors.util';

export type LoadingFailureMessage = Readonly<{
  messages: readonly string[];
  // The introductory message of the failure.
  title?: string;
}>;

interface LoadingState {
  readonly isLoading: boolean;
  readonly isError: boolean;
  readonly error: unknown;
  readonly isFound: boolean;
  readonly subject: string;
  readonly notFoundMessage: string;
}

export const getLoadingFailureMessage = ({
  isLoading,
  isError,
  error,
  isFound,
  subject,
  notFoundMessage,
}: Readonly<LoadingState>): LoadingFailureMessage | undefined => {
  if (isError) {
    return {
      title: `Impossible de charger ${subject}`,
      messages: describeErrors(error),
    };
  }

  if (!isLoading && !isFound) {
    return { messages: [notFoundMessage] };
  }

  return undefined;
};
